/* Spec PWA-014 D-12 (como no admin e na OSP) — para onde voltar depois de entrar (?voltar=, aviso tocado sem sessao).
   So caminho interno do app: comeca com "/", nao com "//" ou "/\" (outro site), sem espaco, e nunca uma tela publica
   (evita voltar para a propria entrada). Guardado na sessao do navegador porque a entrada pode passar por varias telas
   (codigo, cadastro) antes de terminar. */

export const PUBLIC_PATHS = ['/boas-vindas', '/entrar', '/cadastro', '/recuperar-senha', '/codigo', '/l/']
const RETURN_KEY = 'gpd-return-to'

export function safeReturnPath(value: unknown): string | undefined {
    if (typeof value !== 'string' || value.length > 512 || !/^\/(?![/\\])[^\s]*$/.test(value)) return undefined
    const path = value.split(/[?#]/)[0]!
    if (path === '/' || PUBLIC_PATHS.some(p => path === p.replace(/\/$/, '') || path.startsWith(p.endsWith('/') ? p : `${p}/`))) return undefined
    return value
}

/** Guarda o caminho pedido (so se for seguro) ate a entrada terminar. */
export function rememberReturnPath(value: unknown) {
    const path = safeReturnPath(value)
    try {
        if (path) sessionStorage.setItem(RETURN_KEY, path)
    } catch { /* storage bloqueado: entra no Inicio */ }
}

/** Le e apaga o caminho guardado (uso unico). */
export function takeReturnPath(): string | undefined {
    try {
        const path = safeReturnPath(sessionStorage.getItem(RETURN_KEY))
        sessionStorage.removeItem(RETURN_KEY)
        return path
    } catch {
        return undefined
    }
}
